<template>
  <div id="sustainabilityDropdown">
    <q-select
      v-if="label"
      :label="label"
      :placeholder="placeholder"
      v-model="selectedData"
      :options="options"
      :map-options="isObjects"
      :option-label="objectKey"
      emit-value
      :dark="false"
      :label-color="selectedData ? 'white' : 'black'"
      id="sustainabilityDropdown"
      :color="color"
      filled
      :dropdown-icon="dropdownIcon"
      dense
      :disable="disable"
      @input="changeInput"
    >
      <template v-slot:[`selected-item`]="props">
        <span v-bind:props="props" class="title">
          {{ isObjects ? props.opt[objectKey] : props.opt }}
        </span>
      </template>
      <template v-slot:option="scope">
        <q-item
          class="bg-white option"
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
          clickable
          v-ripple
        >
          <q-item-section>
            <q-item-label
              class="option-label text-black"
              v-html="scope.opt[objectKey]"
            >
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>
    <q-select
      v-else
      :placeholder="placeholder"
      v-model="selectedData"
      :options="options"
      :map-options="isObjects"
      :option-label="objectKey"
      emit-value
      :dark="false"
      :label-color="selectedData ? 'white' : 'black'"
      id="sustainabilityDropdown"
      :color="color"
      filled
      :dropdown-icon="dropdownIcon"
      dense
      :disable="disable"
      @input="changeInput"
    >
      <template v-slot:[`selected-item`]="props">
        <span v-bind:props="props" class="title">
          {{ isObjects ? props.opt[objectKey] : props.opt }}
        </span>
      </template>
      <template v-slot:option="scope">
        <q-item
          class="bg-white option"
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
          clickable
          v-ripple
        >
          <q-item-section>
            <q-item-label
              class="option-label text-black"
              v-html="scope.opt[objectKey]"
            >
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  export default {
    data: () => ({
      selectedData: "",
    }),
    mounted() {
      this.selectedData = this.model;
      this.$emit("onMounted");
    },
    watch: {
      model: {
        handler(value) {
          this.selectedData = this.model;
        },
        depp: true,
      },
    },
    props: {
      label: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      isObjects: {
        type: Boolean,
        default: false,
      },
      objectKey: {
        type: String,
        default: null,
      },
      options: {
        type: Array,
        default: [],
      },
      dark: {
        type: Boolean,
        default: true,
      },
      dropdownIcon: {
        type: String,
        default: "mdi-chevron-down",
      },

      color: {
        type: String,
        default: "white",
      },
      model: {
        default: "",
      },
      disable: {
        default: false,
        type: Boolean,
      },
    },
    methods: {
      changeInput(value) {
        this.$emit("input", value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: white !important;
  }

  .option-label {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
  }
</style>

<style lang="scss">
  #sustainabilityDropdown {
    .q-field__append {
      color: white !important;
    }
  }
</style>
